var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"related-products"},[_c('h3',{staticClass:"related-products__heading heading-m"},[_vm._v(" "+_vm._s(_vm.heading)+" ")]),(_vm.items)?_c('ul',{staticClass:"related-products__list"},_vm._l((_vm.items),function(item,index){return _c('RelatedProduct',{key:index,attrs:{"path":item.path,"title":item.title}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }